import { createApp } from "vue";
import App from "./App.vue";
import "./assets/vw.scss";
import router from "./route";
import { parseDate } from "@/utils/date";
import "default-passive-events";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import defaultImg from "@/utils/defaultImg.js";
const app = createApp(App);
app.config.globalProperties.$vw = function (px) {
  return `${(((px ? px : 0) / 375) * 100).toFixed(3)}vw`;
};
app.config.globalProperties.$isIos = function () {
  var u = window.navigator.userAgent;
  if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    //安卓手机
    // return "Android";
    return false;
  } else if (u.indexOf("HarmonyOS") > -1 || u.indexOf("OpenHarmony") > -1)  {
    //鸿蒙手机
    // return "Harmony";
    return false;
  } else if (u.indexOf("iPhone") > -1) {
    //苹果手机
    // return "iPhone";
    return true;
  } else if (u.indexOf("iPad") > -1) {
    //iPad
    // return "iPad";
    return false;
  } else if (u.indexOf("Windows Phone") > -1) {
    //winphone手机
    // return "Windows Phone";
    return false;
  } else {
    return false;
  }
};

// JSBridge-分享
const setShare = (config) => {
  const { title, link, img, content } = config;

  const params = {
    title: title || document.title,
    link: link || window.location.href,
    img: img || '',
    content: content || ''
  };
  if (app.config.globalProperties.$isIos()) {
    // iOS
    console.log('iOS', JSON.stringify(params))
    window.webkit?.messageHandlers?.setShare?.postMessage(JSON.stringify(params));
  } else{
    // Android|Harmony
    console.log('Android|Harmony', JSON.stringify(params))
    window.jsext?.setShare(JSON.stringify(params));
  }
};
app.config.globalProperties.$setShare = setShare;
window.$setShare = setShare;

const search = location.search.split("?");
const params = search[1]?.split("&");
if (params) {
  let paramsMap = {};
  params.forEach((item) => {
    const param = item.split("=");
    paramsMap = {
      ...paramsMap,
      [param[0]]: param[1],
    };
  });
  app.config.globalProperties.$times = paramsMap?.times || 0;
} else {
  app.config.globalProperties.$times = 0;
}
app.config.globalProperties.parseDate = parseDate;
app.use(router);
app.use(ElementPlus);
app.use(defaultImg);
app.mount("#app");

// 正式环境屏蔽 console
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}
